<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de création d'un client</h2>
          <FormClient v-model="formData" @submit="submit"></FormClient>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormClient from "@/components/admin/client/forms/formClient.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "addClient",
  components: {
    FormClient,
  },
  data: () => ({
    formData: {
      name: "",
      email: "",
      comment: "",
      userRights: [],
    },
  }),
  props:{
    userRight: Object,
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes clients" },
      { title: "Créer un client" },
    ]);
  },
  methods: {
      submit: async function() {
          
      try {
        await Api.post("clients", {
          name: this.formData.name,
          email: this.formData.email,
          comment: this.formData.comment,
          userRights: this.formData.userRights.map(ur => ur["@id"]),
        });
        
         Swal.fire({
          title: "",
          text: "Le client a été crée.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: 'gestionClients', query: {
                  selected: 'tab-clients',
                },})
      } catch (error) {
        //Dans le cas où la requête à échoué.
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la création du client",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }

    },
  }
};
</script>
